export default () => {
    return {
        // π ----
        // :: MOUNTED ---------------------------::
        // ____
        mounted() {
            this.sticky()
            const tl = gsap.timeline({
                delay: this.$store.enterDelay + 0.8,
            })

            if (this.$refs.logomark) {
                tl.fromTo(this.$refs.logomark, { opacity: 0 }, { duration: 0.3, opacity: 1 })
                    .fromTo(this.$refs.logotext01, { opacity: 0 }, { duration: 0.3, opacity: 1 }, '<0.2')
                    .fromTo(this.$refs.logotext02, { opacity: 0 }, { duration: 0.3, opacity: 1 }, '<0.15')
                    .fromTo(this.$refs.ctaButton, { opacity: 0 }, { duration: 0.3, opacity: 1 }, '<0.25')
            }
        },

        // π ----
        // :: STICKY ---------------------------::
        // ____
        sticky() {
            const sticky = gsap.timeline({
                scrollTrigger: {
                    trigger: document.body,
                    start: '640px top',
                    end: 'bottom bottom',
                    toggleActions: 'play none none reverse',
                },
            })
            gsap.set(this.$refs.sticky, { yPercent: -104 })

            sticky
                .to(this.$refs.sticky, { duration: 0.4, yPercent: 0, ease: 'circ.out' })
                .fromTo(this.$refs.sticky_logomark, { opacity: 0 }, { duration: 0.3, opacity: 1 })
                .fromTo(this.$refs.sticky_logotext01, { opacity: 0 }, { duration: 0.3, opacity: 1 }, '<0.1')
                .fromTo(this.$refs.sticky_logotext02, { opacity: 0 }, { duration: 0.3, opacity: 1 }, '<0.05')
                .fromTo(this.$refs.sticky_nav, { opacity: 0 }, { duration: 0.3, opacity: 1 }, '<0.15')
        },
    }
}
